export class TimeReportModel {
    constructor() {
        this.employeeId = "";
        this.startDateAsString = "";
        this.endDateAsString = "";
        this.projectIds = [];
        this.isCumulative = false;
    }
}
export default class TimeReport extends TimeReportModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
